/*
 * Session vocale du chat élève. Le serveur tient l'autorisation, le budget et
 * la lecture des transcriptions ; le client n'envoie que de l'audio et rend ce
 * que le serveur lui dit. Il ne déclare plus la consommation — elle est
 * enregistrée côté serveur, sans quoi fermer l'onglet suffirait à ne rien
 * décompter.
 *
 * L'URL et le décodage des trames de contrôle vivent dans WebVoiceSession :
 * ce module ne porte que ce que la PAGE affiche.
 */

export type VoiceRefusal = 'unauthorized' | 'forbidden' | 'chat_disabled' | 'exhausted';

export const VOICE_REFUSAL_MESSAGE: Record<VoiceRefusal, string> = {
  unauthorized: 'Ta session a expiré. Recharge la page.',
  forbidden: "Tu n'as pas accès à cette conversation.",
  chat_disabled: "Le chat n'est plus activé. Parles-en à ton parent.",
  exhausted: "Tu as utilisé tout ton temps de parole pour aujourd'hui. On se reparle demain !",
};

/** Secondes → « 8 min » / « 45 s », pour un enfant. */
export function formatSpeechTime(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s} s`;
  const m = Math.round(s / 60);
  return `${m} min`;
}
